export const environment = {
  appVersion: require('../../package.json').version,
  production: true,  
  urlWhatsAppNotificacion:'https://dev.api-notificacion.crm.ingenius.online/',
  apiSignalBase: 'https://dev.sr.crm.ingenius.online/',  
};
